<template>
  <div>
    <v-autocomplete
      :value="nameMaster"
      :items="filterNameMasters"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :multiple="isMultiple"
      :loading="n_loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      :dense="dense"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="off"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="isMultiple">
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
          </div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item v-if="!hideAddNew">
        <div class="actionBox">
          <v-btn small text color="info" @click="nameMasterCreateDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t(addNewLabel) }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-name-master-create
      @select="selectName"
      :showDialog="nameMasterCreateDialog"
      :type="type"
      :addNewLabel="addNewLabel"
    ></z-name-master-create>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "NameMasterSelect",
  props: {
    value: {
      default: null,
    },
    label: {
      default: "Name Master",
    },
    addNewLabel: {
      default: "Add New Name",
    },
    multiple: {
      default: false,
    },
    type: {
      default: null,
    },
    dense: {
      default: null,
    },
    id: {
      default: false,
    },
    clearable: {
      default: false,
    },
    hideAddNew: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class NameMasterSelect extends (Vue, Themeable) {
  nameMaster = null;
  nameMasters = [];
  n_loading = true;
  filter = "";
  nameMasterCreateDialog = false;
  isMultiple = false;
  selectedValue = null;

  async selectName(newName) {
    this.nameMasterCreateDialog = false;
    if (newName) {
      // this.selectedValue = newName.name;
      if (this.id == true || this.id == "true") {
        this.value = newName._id;
      } else {
        this.value = newName.name;
      }
    }
    // await this.init(this.type);
  }

  clear() {
    this.filter = "";
    this.nameMaster = null;
    this.$emit("input", null);
  }

  get filterNameMasters() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.nameMasters;
    const fs = this.nameMasters.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (!this.isMultiple) {
      if (newVal && newVal.name) {
        if (this.id == true || this.id == "true") {
          this.$emit("input", newVal._id);
        } else {
          this.$emit("input", newVal.name);
        }
        return;
      }
      if (!newVal) this.$emit("input", null);
    } else {
      const response = [];

      if (this.id == true || this.id == "true") {
        for (let i = 0; i < newVal.length; i++) {
          response.push(newVal[i]._id);
        }
      } else {
        for (let i = 0; i < newVal.length; i++) {
          response.push(newVal[i].name);
        }
      }

      this.$emit("input", response);
      return;
    }
  }

  // selectValue() {
  //   if (this.selectedValue && !this.isMultiple) {
  //     for (let i = 0; i < this.nameMasters.length; i++) {
  //       if (this.nameMasters[i].name === this.selectedValue) {
  //         this.nameMaster = this.nameMasters[i];
  //         this.$emit("input", this.nameMaster.name);
  //         return;
  //       }
  //     }
  //   } else {
  //     if (this.selectedValue && Array.isArray(this.selectedValue)) {
  //       for (let j = 0; j < this.value.length; j++) {
  //           for (let i = 0; i < this.nameMasters.length; i++) {
  //             if (this.selectedValue[j] && this.selectedValue[j] == this.nameMasters[i].name) {
  //               this.nameMaster.push(tNames[i]);
  //             }
  //           }
  //           if (found == false) {
  //             const t = { _id: "", name: this.value[j] };
  //             this.nameMaster.push(t);
  //             tNames = !tNames ? [] : tNames;
  //             tNames.push(t);
  //           }
  //         }
  //     }
  //     for (let i = 0; i < this.nameMasters.length; i++) {
  //       if (this.nameMasters[i].name === this.selectedValue) {
  //         this.nameMaster = this.nameMasters[i];
  //         this.$emit("input", this.nameMaster.name);
  //         return;
  //       }
  //     }
  //   }
  // }

  async init(type) {
    if (type) {
      this.nameMaster = null;
      this.isMultiple = this.multiple === "" || this.multiple === true;
      await corpService.populateNameMasters(type);
      let tNames = corpService.nameMasters[type];
      let found = false;
      if (!this.isMultiple) {
        if (tNames) {
          if (this.id == true || this.id == "true") {
            for (let i = 0; i < tNames.length; i++) {
              if (this.value && this.value == tNames[i]._id) {
                this.nameMaster = tNames[i];
                found = true;
                break;
              }
            }
          } else {
            for (let i = 0; i < tNames.length; i++) {
              if (this.value && this.value == tNames[i].name) {
                this.nameMaster = tNames[i];
                found = true;
                break;
              }
            }
          }
        }
        if (found == false && this.value) {
          const t = { _id: "", name: this.value };
          if (this.id == true || this.id == "true") {
            t._id = this.value;
            t.name = "Not available";
          }
          this.nameMaster = t;
          tNames = !tNames ? [] : tNames;
          tNames.push(this.nameMaster);
        }
        this.nameMasters = tNames;

        if (this.nameMaster) {
          if (this.id == true || this.id == "true") {
            this.$emit("input", this.nameMaster._id);
          } else {
            this.$emit("input", this.nameMaster.name);
          }
        }
      } else {
        found = false;
        this.nameMaster = [];
        const nameMaster_name = [];
        if (this.value != null && Array.isArray(this.value)) {
          for (let j = 0; j < this.value.length; j++) {
            if (tNames) {
              if (this.id == true || this.id == "true") {
                for (let i = 0; i < tNames.length; i++) {
                  if (this.value[j] && this.value[j] == tNames[i]._id) {
                    found = true;
                    this.nameMaster.push(tNames[i]);
                  }
                }
              } else {
                for (let i = 0; i < tNames.length; i++) {
                  if (this.value[j] && this.value[j] == tNames[i].name) {
                    found = true;
                    this.nameMaster.push(tNames[i]);
                  }
                }
              }
            }
            if (found == false) {
              const t = { _id: "", name: this.value[j] };
              if (this.id == true || this.id == "true") {
                t._id = this.value[j];
                t.name = "Not available" + j;
              }
              this.nameMaster.push(t);
              tNames = !tNames ? [] : tNames;
              tNames.push(t);
            }
            nameMaster_name.push(this.value[j]);
          }
          tNames = !tNames ? [] : tNames;
          this.nameMasters = tNames;

          this.$emit("input", nameMaster_name);
        }
      }
    } else {
      this.nameMasters = [];
      this.n_loading = false;
      // this.selectValue();
    }
  }

  async mounted() {
    await this.init(this.type);
    this.n_loading = false;
  }

  selected(val) {
    if (val != null && val.name != null && this.nameMaster != null) {
      if (Array.isArray(this.nameMaster)) {
        for (let i = 0; i < this.nameMaster.length; i++) {
          if (val.name === this.nameMaster[i].name) {
            return true;
          }
        }
      } else if (this.nameMaster != null && this.nameMaster.name != undefined) {
        if (val.name === this.nameMaster.name) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    // this.selectedValue = newVal;
    await this.init(this.type);
  }

  @Watch("type", { immediate: true })
  async onTypeChange(val) {
    await this.init(val);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
